import _ from 'lodash';

import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { ContractorsState } from './types';

import { Property } from '@/models';

/**
 * Getters
 *
 * Vuex allows us to define "getters" in the store.
 * - You can think of them as computed properties for stores.
 * - Like computed properties, a getter's result is cached based on its dependencies,
 *   and will only re-evaluate when some of its dependencies have changed.
 */
export const getters: GetterTree<ContractorsState, RootState> = {

	/**
	 * Get the current Property
	 * 
	 * @param { ContractorsState } state
	 * @returns Current client
	 */
	 current: (state: ContractorsState): Property|undefined => {
		return state.current;
	},

	/**
	 * Get the list of Properties
	 * 
	 * @param { ContractorsState } state
	 * @returns List of Properties
	 */
	list: (state: ContractorsState): Property[]|undefined => {
		return state.list;
	},

	/**
   * The updates which have been made since creating/loading/last-saving the current Property
   */
	 hasUnsavedChanges: (state: ContractorsState): boolean => state.updates.length > 0,
}